import * as actionTypes from './actionTypes'

export const resetProjectPreviewPrintFlag = (index, isPortal) => async (dispatch, getState) => {
  dispatch({
    type: actionTypes.RESET_PRINT_FLAG,
  })
}
